import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from './pagination';

export * from './question';

export const HTTP_STATUS = {
  SUCCESS: 200,
  AUTHENTICATION_ERROR: 401,
  AUTHENTICATION_TIMEOUT: 419,
  FORM_ERROR: 422,
  NOT_FOUND: 404,
  FORBIDDEN: 403,
  SERVER_ERROR: 500,
};

export const TOAST_LIFE = 15000;

export const JAPANESE_FULL_STOP = '。';

export const DATE_FORMAT = 'yy/mm/dd';

export const defaultPayload = {
  params: {
    page: DEFAULT_PAGE,
    page_size: DEFAULT_PER_PAGE,
  },
};

export const studentHeaderCsv = [
  '姓(*)',
  '名(*)',
  'セイ(*)',
  'メイ(*)',
  '生年月日',
  '電話番号(*)',
  'メールアドレス(*)',
  '郵便番号(*)',
  '住所(*)',
  'アートシフトコーチのメールアドレス(*)',
];

export const studentBodyCsv = [
  '花城',
  '美羽',
  'ハナシロ',
  'ミウ',
  '1996/02/25',
  '0932008304',
  'tamldm+02@company.com',
  '600000',
  'ベトナム、ダナン市ハイチャウ区ホアホアクオンナム町ab通り',
  'anhntl+coach10@company.com',
];

export const coachHeaderCsv = [
  '姓(*)',
  '名(*)',
  'セイ(*)',
  'メイ(*)',
  '生年月日',
  '電話番号(*)',
  'メールアドレス(*)',
  '郵便番号(*)',
  '住所(*)',
  '卒業期(*)',
  'コース名(*)',
];

export const coachBodyCsv = [
  '西村',
  '大河',
  'ニシムラ',
  'タイガ',
  '1990/01/01',
  '08085450854',
  'abc@xyz.com',
  '7300803',
  '広島県広島市中区北町1-1-25',
  '1',
  '4か​月コース',
];

export const MAX_LENGTH = {
  PHONE_NUMBER: 15,
  PASSWORD: 32,
  ADDRESS: 255,
  POSTCODE: 32,
  NOTE_FOR_CORRECT: 255,
  QUESTION: 1000,
  OPTION: 500,
  GIFT_DESCRIPTION: 300,
  GIFT_POINT: 12,
  GIFT_EMAIL_CONTENT: 2000,
  PLAN_AMOUNT: 10,
}

export const DATE_TIME_FORMAT = {
  DATE_ONLY: 'YYYY/MM/DD',
  DATE_TIME: 'YYYY/MM/DD HH:mm',
  DATE_TIME_HYPHEN: 'yyyy-MM-dd',
};

export const CURRENT_USER_ID_KEY = 'currentUserId';

export const graduationHeaderCsv = [
  '卒業期名(*)',
  '講座開始時期(*)',
  '募集開始(*)',
  'コース名(*)',
  '講座提供利用開始',
  '課金開始(*)',
];

export const graduationBodyCsv = [
  '1',
  '2023/12/17',
  '2024/01/01',
  '4か​月コース',
  '2024/08/15',
  '2024/09',
];

export const UNIPAY_APP_ID = process.env.REACT_APP_UNIPAY_APP_ID;
export const UNIPAY_APP_STORE_ID = process.env.REACT_APP_UNIPAY_STORE_ID ?? '11ed85c4-97bc-a3c4-909a-8b38f9b86180';

export const UPDATE_STATUS_USER_ERROR_CODE = {
  RESUME_SUBSCRIPTION_ERROR: 'MFS-E-LEARNING-ADMIN-RESUME-COACH-1',
  ACTIVE_CHANGE_FAILED: 'MFS-E-LEARNING-ADMIN-RESUME-COACH-2',
  TIMEOUT: 'MFS-E-LEARNING-ADMIN-RESUME-COACH-3',
  INACTIVE_HAVE_PLAN_OR_GRADUATION_INVALID: 'MFS-E-LEARNING-ADMIN-RESUME-COACH-4',
  NOT_FOUND_SUBSCRIPTION: 'MFS-E-LEARNING-ADMIN-RESUME-COACH-5',
  NOT_FOUND_SUBSCRIPTION_TOKEN: 'MFS-E-LEARNING-ADMIN-RECURRING-TOKEN-1',
  INACTIVE_HAVE_PLAN_OR_GRADUATION_INVALID_TOKEN: 'MFS-E-LEARNING-ADMIN-RECURRING-TOKEN-2',
  RESUME_SUBSCRIPTION_ERROR_TOKEN: 'MFS-E-LEARNING-ADMIN-RECURRING-TOKEN-3',
}
